import axios from 'axios'

export default {
  login: async ({commit}, {login, password}) => {
    const params = new URLSearchParams()
    params.append('AUTH_FORM', 'Y')
    params.append('TYPE', 'AUTH')
    params.append('USER_LOGIN', login)
    params.append('USER_PASSWORD', password)
    const result = await axios.post('/auth/login', params)
    if (result.data.success) {
      window.location.reload()
    } else {
      commit('setAuthError', result.data.error)
    }
  },
  loginByPhone: async ({commit, dispatch}, {phone, password}) => {
    const result = await axios.post('/auth/getLoginByPhone', {
      phone: phone
    })
    if (result.data.success) {
      await dispatch('login', {
        login: result.data.login,
        password: password
      })
    } else {
      commit('setAuthError', result.data.error)
    }
  },
  sendSmsByPhone: async ({commit, getters}, {phone}) => {
    const result = await axios.post('/auth/sendSmsByPhone', {
      phone: phone
    })

    if (result.data.success) {
      commit('setPopupType', 'phoneCheck')
      commit('setCurrentPhone', phone)
      commit('setAuthError', null)
    } else {
      commit('setAuthError', result.data.error)
      commit('setCurrentPhone', null)
      if (getters.getIsPopup === true) {
        commit('setPopupType', 'authorize')
      } else {
        commit('setPopupType', null)
      }
    }
  },
  checkPhoneCode: async ({commit, getters}, {code}) => {
    const result = await axios.post('/auth/checkPhoneCode', {
      code: code
    })

    if (result.data.success) {
      window.location.reload()
    } else {
      commit('setAuthError', result.data.error)
      if (getters.getIsPopup === true) {
        commit('setPopupType', 'authorize')
      } else {
        commit('setPopupType', null)
      }
    }
  },
  register: async ({commit, getters}, data) => {
    const result = await axios.post('/auth/register', data)

    if (result.data.success) {
      window.location.reload()
    } else {
      commit('setRegError', result.data.error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/store/modules/auth/actions.js